import { render, staticRenderFns } from "./AddUpdateGradingTable.vue?vue&type=template&id=f4c4579a&"
import script from "./AddUpdateGradingTable.vue?vue&type=script&lang=js&"
export * from "./AddUpdateGradingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports